export const isInvalidTeamName = (teamName: string): false | string => {
  if (!teamName) {
    return 'Please enter a name.'
  }

  return false
}
